<template>
  <b-card class="custom-card white-bg">
    <div :id="downloadId" class="container-line-chart">
      <b-card-header class="">
        <div class="card-text-strong">
          <span class="card-management-title"
            >{{ titleChart }}
            <span v-if="specificSiteId && specificSiteId.length > 0 && !tDateShow"> {{ "_" + getSiteID(this.specificSiteId[0]) }}</span>
          </span>
          <slot></slot>
        </div>
      </b-card-header>
      <b-card-body>
        <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" v-if="dataSource && dataSource.data && Object.keys(dataSource.data).length > 0"> </fusioncharts>
        <div v-else class="align-center p-60">
          <div class="card-text-title no-data" v-if="dataLoaded">
            No Data In
          </div>
          <!-- <div class="card-text-title no-data" v-else><i class="fa fa-spinner fa-spin loaderStyle"></i></div> -->
        </div>
        <div class="col-xl-12 color_slate-grey pt-15" v-bind:class="{ presets: tDateShow }">
          {{ todayDate }}
        </div>
      </b-card-body>
      <div class="text-right" v-if="tDateShow">
        <span class="pr-10" v-if="dataSource && dataSource.data && Object.keys(dataSource.data).length > 0">
          <img src="static/img/download-graphs.png" class="download_graph cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" />
          <div class="dropdown-menu download-dropdown-box p-0 dropdown-menu-right">
            <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs(titleChart, 'csv', downloadId)"><img src="/static/img/csv.svg" class="mr-6" />CSV</span>
            <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs(titleChart, 'pdf', downloadId)"><img src="/static/img/pdf.svg" class="mr-6" />PDF</span>
            <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadGraphs(titleChart, 'png', downloadId)"><img src="/static/img/img.svg" class="mr-6" />PNG</span>
          </div>
        </span>

        <span @click="zoomGraph(true)" class="cursor_pointer pr-20" title="Expand" v-if="!zoomGraphValueChild && dataSource && dataSource.data && Object.keys(dataSource.data).length > 0">
          <img src="/static/img/expandbox.svg" class="download_graph" />
        </span>
        <span @click="zoomGraph(false)" class="cursor_pointer pr-20" v-if="zoomGraphValueChild && dataSource && dataSource.data && Object.keys(dataSource.data).length > 0" title="Collapse">
          <img src="/static/img/unexpand.svg" class="download_graph" />
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import Vue from "vue";
import VueFusionCharts from "vue-fusioncharts";
import FusionCharts from "fusioncharts";
import { downloadCSV, getSiteID } from "../../../services/visualization/data-management";
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import _ from "lodash";

Vue.use(VueFusionCharts, FusionCharts);

const primaryColorFnc = function() {
  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#00C3B3";
  return primaryColor;
};

export default {
  props: {
    downloadId: { type: String, default: "" },
    xAxisName: { type: String, default: "" },
    yAxisName: { type: String, default: "" },
    data: { type: Array, default: () => [] },
    tooltip: { type: String, default: "" },
    tab: { default: 0 },
    containerClass: {
      type: String,
      default: "thread-chart",
      zoomGraphValueChild: ""
    },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    specificSiteId: { type: Array, default: () => {} },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      type: "line",
      dataFormat: "json",
      renderAt: "chart-container",
      width: "100%",
      height: "250",
      dataSource: {
        chart: {
          // xAxisNameFontColor: "#959fa4",
          xAxisNameFont: "RobotoRegular",
          xAxisNameFontSize: "9px",
          labelFontSize: "10px",
          labelFont: "RobotoRegular",
          labelFontColor: "#a3a3a3",
          anchorBgHoverColor: primaryColorFnc(),
          yAxisNameFont: "RobotoRegular",
          yAxisNameFontSize: "9px",
          yAxisValueFont: "RobotoRegular",
          yAxisValueFontSize: "10px",
          yAxisValueFontColor: "#a3a3a3",
          showLegend: false,
          lineThickness: "2",
          compactdatamode: "1",
          dataSeparator: "|",
          theme: "fusion",
          xAxisName: this.xAxisName,
          yAxisName: this.yAxisName,
          xAxisNameFontColor: "#959fa4",
          yAxisNameFontColor: "#959fa4",
          divLineAlpha: "0",
          divLineDashed: "0",
          anchorBgColor: primaryColorFnc(),
          anchorBorderColor: primaryColorFnc(),
          paletteColors: primaryColorFnc() + ",#a6cee3,#7891d1,#56b3b9,#cab2d6,#7f69d4,#fb9a99,#fdbf6f,#b5cdd8",
          tooltipBorderAlpha: "0",
          toolTipBgAlpha: "0",
          plotToolText: `$dataValue ${this.tooltip}`,
          canvasPadding: 50,
          numbersuffix: "",
          canvasTopPadding: "10",
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          drawCrossLine: false,
          chartBottomMargin: "0",
          xAxisNamePadding: "5",
          decimals: 0
        },
        data: this.data
      },
      zoomGraphValueChild: "",
      todayDate: "",
      tDateShow: true,
      getSiteID
    };
  },

  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    data: function(newValue) {
      this.dataSource.data = newValue;
      this.dataSource.chart.anchorBgColor = primaryColorFnc();
      this.dataSource.chart.anchorBgHoverColor = primaryColorFnc();
      this.dataSource.chart.anchorBorderColor = primaryColorFnc();
      this.dataSource.chart.paletteColors = primaryColorFnc() + ",#a6cee3,#7891d1,#56b3b9,#cab2d6,#7f69d4,#fb9a99,#fdbf6f,#b5cdd8";
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    },
    tab: function(newValue) {
      const isPercenTab = newValue === 1;
      const percen = isPercenTab ? "%" : "";

      this.dataSource.chart.numbersuffix = percen;
      this.dataSource.chart.yaxismaxvalue = isPercenTab ? "100" : "";
      this.dataSource.chart.plotToolText = this.generateTooltips("", this.tooltip);
    }
  },
  methods: {
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    generateTooltips(percent, tooltipTitle) {
      const tooltips = `
        <span class="overall-collection-metric-tooltip completed">
            $dataValue${percent + " " + tooltipTitle}
        </span>
      `;

      return tooltips;
    },
    downloadGraphs(titleChart, type, downloadId) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        switch (type) {
          case "csv":
            const header = ["Days", "Total Queries"];
            this.tDateShow = true;
            header[1] = this.tab < 1 ? "Total Queries" : "Percentage Queries";

            const newArr = [];
            this.data.map(row => {
              const value = this.tab < 1 ? row.value : row.value + "%";
              newArr.push([row.label, value]);
            });

            downloadCSV(titleChart, header, newArr, this.specificSiteId);
            break;
          case "pdf":
            let filename = titleChart + "_" + this.todayDate + ".pdf";
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".pdf";
            }
            let container = document.querySelector("#" + downloadId);
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(canvas => {
              const imgData = canvas.toDataURL("image/png");
              const pdf = new jspdf("p", "mm", "a4");
              const imgProps = pdf.getImageProperties(imgData);
              const pdfWidth = pdf.internal.pageSize.getWidth();
              const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
              pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
              pdf.save(filename);
            });
            break;
          case "png":
            if (this.specificSiteId && this.specificSiteId.length > 0) {
              filename = titleChart + "_" + this.todayDate + "_" + getSiteID(this.specificSiteId[0]) + ".png";
            }
            this.tDateShow = true;
            html2canvas(container, {
              allowTaint: true,
              logging: false,
              scrollY: -window.scrollY,
              scrollX: -window.scrollX - 6,
              onclone: function(document) {
                document.querySelectorAll(".nav-item").forEach(element => {
                  const ele = element.querySelector(".nav-link.active");
                  if (!ele) {
                    element.remove();
                  }
                });
              }
            }).then(function(canvas) {
              const link = document.createElement("a");
              document.body.appendChild(link);
              link.download = filename;
              link.href = canvas.toDataURL("image/png");
              link.target = "_blank";
              link.click();
            });
            break;
        }
      }, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
}
</style>
